import { NgModule } from '@angular/core';
import { RouterModule } from '@angular/router';
import { ProfissionalInserirComponent } from './profissional-inserir.component';


@NgModule({
    imports: [RouterModule.forChild([
        { path: '', component: ProfissionalInserirComponent }
    ])],
    exports: [RouterModule]
})
export class ProfissionalInserirRoutingModule { }
